import request from '@/plugins/axios'

export function setLanguage(data) {
  return request({
    url: '/setLanguage',
    method: 'post',
    data
  })
}